import { gql } from '@apollo/client';

export const queryGetCompanies = gql`
  query CompaniesQuery($term: String) @api(name: admin) {
    companies(term: $term) {
      id
      title
      country {
        id
        name
      }
      city {
        id
        name
      }
      address1
      zip
      vatNumber
      website
      email
    }
  }
`;

export const queryGetPaymentTerms = gql`
  query PaymentTermsQuery($term: String) @api(name: admin) {
    paymentTerms(term: $term) {
      id
      title
    }
  }
`;

export const queryGetBanks = gql`
  query BanksQuery($term: String) @api(name: admin) {
    banks(term: $term) {
      id
      title
    }
  }
`;
